import defaultMessages from 'modules/i18n/messages.json';

export const getMessage = (id: string) => defaultMessages[id] || '';
